import { centsToDollars } from '@nsb/core';
import { useState } from 'react';
import { committed } from './moneyCommit.ts';

/**
 * Dollars in, cents out. Blank is null, never zero. Portal money (integer
 * cents), so it stays out of the shared primitives in ui.tsx. It commits on
 * leaving the field (`onChange`); `onTyping` reads it as it is typed, for what
 * the amount makes shown beside it (a budget's split), never to save.
 */
export function MoneyInput({
  value,
  onChange,
  id,
  placeholder = '—',
  className = '',
  'aria-label': ariaLabel,
  onTyping,
}: {
  value: number | null;
  onChange: (cents: number | null) => void;
  /** What the field reads as now, as it would commit: blank null, words it cannot read as money what was there. */
  onTyping?: (cents: number | null) => void;
  id?: string;
  placeholder?: string;
  className?: string;
  'aria-label'?: string;
}) {
  const [text, setText] = useState(value === null ? '' : String(centsToDollars(value)));
  const [focused, setFocused] = useState(false);
  const shown = focused ? text : value === null ? '' : centsToDollars(value).toLocaleString('en-US', { maximumFractionDigits: 2 });
  return (
    <div className={`flex items-baseline gap-1 ${className}`}>
      <span className="num text-ink-3">$</span>
      <input
        id={id}
        aria-label={ariaLabel}
        inputMode="decimal"
        className="field num"
        value={shown}
        placeholder={placeholder}
        onFocus={() => {
          setText(value === null ? '' : String(centsToDollars(value)));
          setFocused(true);
        }}
        onChange={(e) => {
          setText(e.target.value);
          onTyping?.(committed(e.target.value, value).value);
        }}
        onBlur={() => {
          setFocused(false);
          const left = committed(text, value);
          if (left.commit) onChange(left.value);
        }}
      />
    </div>
  );
}
